import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useSelector } from "react-redux";
import {
  selectActors,
  selectSelectedElement,
} from "../../app/slices/TrainingSlice";
import { ActorState } from "../../models/ActorState";
import EditorColumn, {
  EditorColumnHeader,
} from "../editor_columns/EditorColumn";
import ActorStatePropertiesBreadcrumb from "./ActorStatePropertiesBreadcrumb";
import ActorStatePropertiesEditor from "./ActorStatePropertiesEditor";

export default function ActorStatePropertiesColumn() {
  const selectedActorState = useSelector(selectSelectedElement) as ActorState;
  const actorPreset = useSelector(selectActors).find(
    (actor) => actor.id === selectedActorState?.actorId
  );

  return (
    <EditorColumn
      testId="actor-state-properties-column"
      widthClassName="w-full min-w-0"
      borderSide="left"
      header={
        <EditorColumnHeader
          icon={<AccountCircleOutlinedIcon fontSize="inherit" />}
          title={actorPreset?.workingName ?? "No Name"}
          testId="actor-state-properties-header"
        />
      }
    >
      <div className={"h-full"}>
        <ActorStatePropertiesBreadcrumb />
        <ActorStatePropertiesEditor />
      </div>
    </EditorColumn>
  );
}
